<menu-component #menu [isSimpleMenu]="_publicPortalMode" *ngIf="loginService.isLoggedInLocally(_user) && notOnForbiddenPage()"></menu-component>
<global-alert-component></global-alert-component>
<localization-component></localization-component>
<div class="contentDiv" (click)="handleClickContent()">
    <router-outlet class="router-outlet"></router-outlet>
</div>
<profiler></profiler>
<sass-helper></sass-helper>
